<!-- 
  編集メイン画面
-->
<template>
  <div>
    <div class="container-fluid" style="height: 100vh; min-width: 1400px; font-family: 'Noto Sans JP'; color: #595959; overflow-y: hidden;">
      <HomeTop_Ap />
      <div class="row home-body acry-pro-bg-color p-0 position-relative">
        <div class="p-0 leftmenu">
          <LeftMenu_Ap />
        </div>
        <div class="col h-100 p-0 contents_box" ref="CenterViewRef" style="">
          <Center_Ap class="h-100 w-100" />
        </div>
        <div class="p-0" style="width: 300px;" v-show="this.$store.state.isShowRightMenu">
        <RightMenu_Ap />
        </div>
        <transition name="cartmenu-background">
          <div
            class="cartmenu-background" 
            @click="clickCartBackground" 
            v-show="this.$store.state.isShowCart"
          >
          </div>
        </transition>
        <transition name="cartmenu">
          <div
            class="cart-menu"
            v-show="this.$store.state.isShowCart"
          >
            <RightMenuCart_Ap />
          </div>
        </transition>
      </div>
      <ListPreview v-if="isShowListPreview()" />
      <Loading v-if="isLoading()" />
      <LoadingProgress v-if="this.$store.state.isShowProgress" />
      <transition name="alert">
        <AlertDialog v-if="isAlertDialog()" />
      </transition>
      <transition name="alert">
        <CartInAlertDialog v-if="isCartInAlertDialog()" />
      </transition>
      <transition name="alert">
        <ImagePreviewPopup v-if="isShowImagePreview()" />
      </transition>
      <transition name="alert">
        <ImagesPreviewPopup v-if="isShowImagesPreview()" />
      </transition>
      <transition name="alert">
        <YesNoDialog v-if="this.$store.state.isShowYesNoDialog" />
      </transition>
      <transition name="alert">
        <OrderHistoryDesignDetail v-if="isShowDesign()" />
      </transition>
      <transition name="alert">
        <ReOrderOption_Ap v-if="this.$store.state.isShowReOrderOption" />
      </transition>
      <transition name="alert">
        <ReOrderDesign_Ap v-if="this.$store.state.isShowReOrderDesign" />
      </transition>
      <transition name="alert">
        <InputTextDialog v-if="this.$store.state.isShowInputText" />
      </transition>
      <transition name="alert">
        <ImagePopup v-if="this.$store.state.isImagePopup" />
      </transition>
      <transition name="alert">
        <ResendContractDialog v-if="this.$store.state.isResendContractDialog" />
      </transition>
      <Estimates v-if="this.$store.state.isShowEstimates" />
      <transition name="alert">
        <CardPayment_Ap v-if="this.$store.state.cardPayment.isShow" />
      </transition>

      <!-- チュートリアル用 -->
      <div class="tutorial-bg" v-if="this.$store.state.tutorial.isShowBG"></div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import YesNoDialog from "@/components/acyrpro/modal/dialog/YesNoDialog_Ap.vue";
import ImagePreviewPopup from "@/components/acyrpro/modal/ImagePreviewPopup_Ap.vue";
import ImagesPreviewPopup from "@/components/acyrpro/modal/ImagesPreviewPopup_Ap.vue";
import OrderHistoryDesignDetail from "@/components/modal/dialog/OrderHistoryDesignDetail.vue";
import Loading from "@/components/modal/dialog/Loading.vue";
import AlertDialog from "@/components/acyrpro/modal/dialog/AlertDialog_Ap.vue";
import CartInAlertDialog from "@/components/acyrpro/modal/dialog/CartInAlertDialog_Ap.vue";
import firebase from "firebase/app";
import "firebase/database";
import "firebase/storage";
import { SaleProductManager } from "@/js/SaleProductManager.js";
import { User } from "@/js/User.js";
import HomeTop_Ap from "../components/acyrpro/HomeTop_Ap.vue";
import LeftMenu_Ap from "../components/acyrpro/LeftMenu_Ap.vue";
import Center_Ap from "../components/acyrpro/Center_Ap.vue";
import RightMenu_Ap from "../components/acyrpro/RightMenu_Ap.vue";
import RightMenuCart_Ap from "../components/acyrpro/RightMenuCart_Ap.vue";
import { RealtimeDatabaseTableName } from "@/js/Const.js";
import { CartManager } from "@/js/CartManager.js";
import { OptionManager } from "@/js/OptionManager.js";
import { DraftManager } from "@/js/DraftManager.js";
import { OrderHistoryManager } from "@/js/OrderHistoryManager.js";
import { AcrylicTicketCouponManager } from "@/js/AcrylicTicketCouponManager.js";
import { CampaignManager } from "@/js/CampaignManager.js";
import ReOrderOption_Ap from "@/components/acyrpro/modal/ReOrderOption_Ap.vue";
import ReOrderDesign_Ap from "@/components/acyrpro/modal/ReOrderDesign_Ap.vue";
import InputTextDialog from "../components/acyrpro/modal/dialog/InputTextDialog.vue";
import router from "@/router";
import Estimates from "@/components/acyrpro/modal/Estimates_Ap.vue";
import CardPayment_Ap from "@/components/acyrpro/modal/CardPayment_Ap.vue";
import ImagePopup from "../components/acyrpro/modal/dialog/ImagePopup.vue";
import ListPreview from "../components/acyrpro/modal/ListPreview_Ap.vue";
import LoadingProgress from "@/components/acyrpro/modal/dialog/LoadingProgress_Ap.vue";
import ResendContractDialog from "@/components/acyrpro/modal/dialog/ResendContractDialog_Ap.vue";
import { Analytics } from "@/js/Analytics.js";
import { Logger } from '@/js/utils/Logger.js';

export default {
  name: "Home",
  components: {
    Loading,
    AlertDialog,
    OrderHistoryDesignDetail,
    YesNoDialog,
    CartInAlertDialog,
    // TextBrowserEdit,
    HomeTop_Ap,
    LeftMenu_Ap,
    Center_Ap,
    RightMenu_Ap,
    RightMenuCart_Ap,
    ReOrderOption_Ap,
    ReOrderDesign_Ap,
    InputTextDialog,
    Estimates,
    ImagePopup,
    CardPayment_Ap,
    ListPreview,
    LoadingProgress,
    ImagePreviewPopup,
    ImagesPreviewPopup,
    ResendContractDialog,
  },
  data() {
    return {
      cantUse: false,
      signatureCheckTimer: null,
      envelopeXID: "",
    };
  },
  async mounted() {
    this.$store.commit("setCenterViewRef", this.$refs.CenterViewRef);
    this.$store.commit("hideLoading");
    this.$store.commit("hideProgress");
    this.$store.commit("hideMessage");
    this.$store.commit("hideProgress");
    this.$store.commit("setHome", this);
    await User.getInfo();
    Logger.debug(User.userData);
    if (User.userData.approval_status != "2") {
      this.cantUse = true;
      return;
    }

    await User.getFBAcryProUserData().then((data) => {
      this.envelopeXID = data && "envelopeXID" in data && data.envelopeXID;
      var isSignature = data && "isSignature" in data && data.isSignature;
      this.$store.commit("setIsSignature", isSignature);
    });

    // 署名が完了いていない場合は1分おきにチェック
    if (!this.$store.state.isSignature) {
      User.checkSignature(this.envelopeXID).then((response) => {
        if (response["status"] == 4) {
          // 署名完了
          User.updateFBAcryProInfo({ isSignature: true });
          Analytics.contractSigned();
          this.$store.commit("setIsSignature", true);
        }else{
          // 1分に一回署名状況の確認
          this.signatureCheckTimer = setInterval(
            function () {
              User.checkSignature(this.envelopeXID).then((response) => {
                if (response["status"] == 4) {
                  // 署名完了
                  User.updateFBAcryProInfo({ isSignature: true });
                  Analytics.contractSigned();
                  this.$store.commit("setIsSignature", true);
                  clearInterval(this.signatureCheckTimer);
                }
              });
            }.bind(this),
            60000
          );
        }
      });
    }

    await this.$store.state.optionManager.update().catch((e) => {
      this.$common.log(e);
      this.$store.commit("hideLoading");
      this.$store.commit("showMessage", "エラーが発生しました");
    });
  },
  created: function () {
    // ログインしていない場合はログイン画面
    if (!firebase.auth().currentUser) {
      router.replace("/");
      return;
    }

    var self = this;

    // ヒストリーデータの取得
    var historyRef = firebase
      .database()
      .ref(RealtimeDatabaseTableName.HistoryData + "/" + firebase.auth().currentUser.uid);
    historyRef.on("value", function (snapshot) {
      let list = snapshot.val() ? snapshot.val() : [];
      self.$store.commit("setUserHistoryData", list);
    });

    self.$store.commit("setSaleProductManager", new SaleProductManager());
    self.$store.commit("setCartManager", new CartManager());
    self.$store.commit("setDraftManager", new DraftManager());
    self.$store.commit("setOptionManager", new OptionManager());
    self.$store.commit("setOrderHistoryManager", new OrderHistoryManager());
    self.$store.commit("setAcrylicTicketCouponManager", new AcrylicTicketCouponManager());
    self.$store.commit("setCampaignManager", new CampaignManager());
  },
  beforeRouteLeave(to, from, next) {
    if( this.$store.state.isLogout ){
      this.$store.commit("resetData");
      next();
      return;
    }
    const answer = window.confirm("編集中のものは保存されませんが、よろしいですか？");
    if (answer) {
      next();
    } else {
      next(false);
    }
  },
  destroyed() {
    window.removeEventListener("beforeunload", this.confirmSave);
  },
  methods: {
    isModal: function () {
      return this.$store.state.isModal;
    },
    isProductHistoryModal: function () {
      return this.$store.state.isProductHistoryModal;
    },
    isLoading: function () {
      return this.$store.state.isLoading;
    },
    isAlertDialog: function () {
      return this.$store.state.isAlertDialog;
    },
    isCartInAlertDialog: function () {
      return this.$store.state.isCartInAlertDialog;
    },
    isShowDesign: function () {
      return this.$store.state.isShowDesign;
    },
    isShowListPreview: function () {
      return this.$store.state.isShowListPreview;
    },
    isShowImagePreview: function () {
      return this.$store.state.isShowImagePreview;
    },
    isShowImagesPreview: function () {
      return this.$store.state.isShowImagesPreview;
    },
    clickCartBackground(){
      if( this.$store.state.isShowCart ){
        this.$store.commit("switchShowCart");
      }
    }
  },
  computed: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.home {
  --canvas-width: 100%;
  --canvas-height: 900px;

  width: var(--canvas-width);
  min-width: 1300px;
  height: var(--canvas-height);

  display: flex;
  flex-direction: column;
  align-items: stretch;

  user-select: none; /* 選択を禁止する */
  background: rgb(235, 236, 231);
}
.home-body{
  height: calc(100vh - #{$header-height});
  background: $background-purplegray-color;
}
.home-textedit {
  min-width: 300px;
}
.home-product {
  min-width: 200px;
}
.home-menu {
  height: 50px;
}
.flexmain {
  display: flex;
  flex-direction: row;
  align-items: stretch;

  height: 850px;
  min-width: 1000px;
}
.flexmain-tool {
  width: 50px;
}
.flexmain-main {
  flex: 1;
}
.flexsub-sidetab {
  width: 275px;
  height: 790px;
}
.flexsub-property {
  flex: 1;
}
.flexsub-layer {
  flex: 1;
}

.alert-enter {
  opacity: 0;
}
.alert-enter-to {
  opacity: 1;
}
.alert-enter-active {
  transition: all 0.3s 0s ease;
}
.alert-leave {
  opacity: 1;
}
.alert-leave-to {
  opacity: 0;
}
.alert-leave-active {
  transition: all 0.3s 0s ease;
}
.dark {
  background-color: rgb(73, 73, 73);
}
.cart-menu {
  background: $background-purplegray-color;
  height: calc(100vh - #{$header-height});
  margin: 0px;
  width: 300px;
  padding: 8px;
  padding-top: 0px;
  right: 0px;
  position: absolute;
  z-index: 4;
}
.cartmenu-enter-to {
  transition: transform 0.5s ease-out;
  transform: translateX(0px);
}
.cartmenu-enter {
   transform: translateX(300px); 
}

.cartmenu-leave-to {
  transition: transform 0.5s ease-out;
  transform: translateX(300px);
}
.cartmenu-leave-from {
  transform: translateX(0px);
}
.leftmenu{
  width: $leftmenu-width;
}

.cartmenu-background{
  position: absolute;
  top: 0px;
  height: 100%;
  width: 100;
  background: #000000aa;
  z-index: 3;
}

.cartmenu-background-enter {
  background: #00000000;
}
.cartmenu-background-enter-to {
  transition: all 0.5s ease-out;
  background: #000000aa;
}
.cartmenu-background-leave-from {
  background: #000000aa;
}
.cartmenu-background-leave-to {
  transition: all 0.5s ease-out;
  background: #00000000;
}
.contents_box::-webkit-scrollbar{
  display: none;
}
.contents_box {
  background: $background-white-color;
  min-width: 490px;
  overflow: scroll;
}
.tutorial-bg{
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 2;
  background: black;
  opacity: 0.7;
}
</style>
